import { exportExcel } from '../utils/exportUtils';

/**
 * Thin wrapper over utils/exportUtils.js's exportExcel for report tables.
 * `sections` is [{ data, columns, columnKeys, columnTypes, title? }] - see
 * exportUtils.js for the full contract (it also accepts a `filters` block
 * for a filter-summary header, which report views can pass through).
 * exportExcel names each Excel sheet from `section.title` even for a single
 * section, so default it here rather than require every call site to set it.
 */
export default function ExportButton({ fileName, sections, disabled }) {
	const namedSections = sections.map((s, i) => ({ title: sections.length > 1 ? `Sheet ${i + 1}` : fileName, ...s }));

	return (
		<button
			type='button'
			className='btn-secondary'
			disabled={disabled || !sections.some((s) => s.data?.length)}
			onClick={() => exportExcel(fileName, namedSections)}
		>
			Export
		</button>
	);
}
